import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class SearchBox extends BaseComponent {
  constructor(props) {
    super(props);
    this.timeout = null;
  }

  handelChange() {
    this.props.onUserInput(
      this.refs.searchInput.value
    );

    if (this.refs.searchInput.value.length > 0) {
      $('#searchClearBtn').css('display', 'block');
      $("#searchResultsOpenBtn").css('display', 'none');
    }
    else {
      $('#searchClearBtn').css('display', 'none');
    }
  }

  handelChangeDelay() {
    window.clearTimeout(this.timeout);
    this.timeout = window.setTimeout(this.handelChange, 300);
  }

  render() {
    return (
      <div className={["input-field", styles.searchBox].join(" ")}>
        <input type="text"
               placeholder="Search"
               ref="searchInput"
               onChange={this.handelChangeDelay}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/searchBox.jsx